import { FC, ReactNode, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTopBar } from 'src/contexts/TopBarContext';

interface TopBarTitleWrapperProps {
  children?: ReactNode;
}

const TopBarTitleWrapper: FC<TopBarTitleWrapperProps> = ({ children }) => {
  const { setTopBarContent } = useTopBar();

  useEffect(() => {
    setTopBarContent(children);
    return () => setTopBarContent(null);
  }, [children, setTopBarContent]);

  // Return null to not render anything on the page
  return null;
};

TopBarTitleWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default TopBarTitleWrapper; 